export default __webpack_public_path__ + "static/media/blue-favorite-icon.0cfed354.svg";